import type { FunctionComponent } from 'react';

const CompleteIntroduction: FunctionComponent = function () {
  return <p>CompleteIntroduction</p>;
};

CompleteIntroduction.displayName = 'CompleteIntroduction-view';

export default CompleteIntroduction;
